export default __webpack_public_path__ + "static/media/University_of_Strathclyde.290ae258.png";